import React, { useEffect, useState } from 'react';

export default function ScrollProgress() {
  const [p, setP] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const h = document.documentElement;
      const scrolled = (h.scrollTop || document.body.scrollTop);
      const total = h.scrollHeight - h.clientHeight;
      setP(total > 0 ? (scrolled / total) * 100 : 0);
    };
    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className="fixed top-0 inset-x-0 h-[2px] z-[60] pointer-events-none">
      <div className="h-full bg-[#d42b92] transition-[width] duration-150" style={{ width: `${p}%` }} />
    </div>
  );
}
